import loadable from "@loadable/component";
import { ErrorBoundary } from "../../components";
import FullPageLoader from "@Components/FullPageLoader";

const AsyncScholarshipV2 = loadable(() => import("./ScholarshipV2"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <AsyncScholarshipV2 {...props} />
  </ErrorBoundary>
);
